"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPoolList = exports.poolListFromSolidityStruct = exports.tokensFromTree = exports.buildMerklTree = void 0;
const ethers_1 = require("ethers");
const keccak256_1 = __importDefault(require("keccak256"));
const merkletreejs_1 = __importDefault(require("merkletreejs"));
const utils_1 = require("../types/utils");
const buildMerklTree = (underylingTreeData, user) => {
    var _a, _b;
    const users = [];
    for (const id of Object.keys(underylingTreeData)) {
        const rewardUsers = Object.keys(underylingTreeData[id].holders);
        for (const r of rewardUsers) {
            if (!users.includes(r)) {
                users.push(r);
            }
        }
    }
    const tokens = (0, exports.tokensFromTree)(underylingTreeData);
    const elements = [];
    const transactionData = {};
    for (const u of users) {
        for (const t of tokens) {
            let sum = ethers_1.BigNumber.from(0);
            for (const id of Object.keys(underylingTreeData)) {
                const distribution = underylingTreeData[id];
                if (distribution.token === t) {
                    sum = sum === null || sum === void 0 ? void 0 : sum.add((_b = (_a = distribution === null || distribution === void 0 ? void 0 : distribution.holders[u]) === null || _a === void 0 ? void 0 : _a.amount.toString()) !== null && _b !== void 0 ? _b : 0);
                }
            }
            const hash = ethers_1.ethers.utils.keccak256(ethers_1.ethers.utils.defaultAbiCoder.encode(['address', 'address', 'uint256'], [ethers_1.utils.getAddress(u), t, sum]));
            if (u === user) {
                transactionData[t] = { claim: sum.toString(), leaf: hash, token: t };
            }
            elements.push(hash);
        }
    }
    const tree = new merkletreejs_1.default(elements, keccak256_1.default, { hashLeaves: false, sortPairs: true });
    for (const k of Object.keys(transactionData)) {
        transactionData[k].proof = tree.getHexProof(transactionData[k].leaf);
    }
    return {
        transactionData,
        tree,
    };
};
exports.buildMerklTree = buildMerklTree;
const tokensFromTree = (json) => {
    const tokens = [];
    for (const id of Object.keys(json)) {
        if (!tokens.includes(json[id].token)) {
            tokens.push(json[id].token);
        }
    }
    return tokens;
};
exports.tokensFromTree = tokensFromTree;
const poolListFromSolidityStruct = (data) => {
    var _a;
    const pools = [];
    for (const d of data) {
        if (!pools.map((pool) => pool.address).includes(d.base.uniV3Pool)) {
            pools.push({ address: d.base.uniV3Pool, amm: (0, utils_1.findMerklAMMTypeDeprecated)((_a = d.base.additionalData) === null || _a === void 0 ? void 0 : _a.toString()) });
        }
    }
    return pools;
};
exports.poolListFromSolidityStruct = poolListFromSolidityStruct;
const buildPoolList = (chainId, data) => __awaiter(void 0, void 0, void 0, function* () {
    const pools = [];
    yield Promise.all(data.map((d) => __awaiter(void 0, void 0, void 0, function* () {
        return (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const amm = yield (0, utils_1.fetchMerklAMMType)(chainId, d.base.uniV3Pool);
                if (!pools.map((pool) => pool.address).includes(d.base.uniV3Pool)) {
                    pools.push({ address: d.base.uniV3Pool, amm: amm });
                }
            }
            catch (_a) {
                console.log(`${d.base.uniV3Pool.toLowerCase()} not found in the graphs`);
            }
        }))();
    })));
    return pools;
});
exports.buildPoolList = buildPoolList;
//# sourceMappingURL=merkl.js.map